import { Box, Text } from '@chakra-ui/react'
import { toCamelCase } from '../../utils/schemaUtils'

export function generatePatientFields(field: any, values: any) {
  const value = values[toCamelCase(field.displayName)]
  if (!value) return null

  return (
    <Box key={field.id} mb={4}>
      <Text
        fontSize="xs"
        fontWeight="bold"
        color="gray.500"
        textTransform="uppercase"
        letterSpacing="wider"
        mb={1}
      >
        {field.displayName}
      </Text>
      <Text fontSize="md" color="gray.800" fontWeight="medium">
        {value}
      </Text>
    </Box>
  )
}
